export default class DBG {
    static log(msg, ...parameters) {
        if (DBG.LOGGING_ON) {
            console.log(msg, parameters);
        }
    }
}
DBG.LOGGING_ON = true;
